<template>
  <div>
    <div class="about-container-1">
      <section class="about-title-container-1">
        <span class="about-header"
          >About <span style="color: white">1/6</span></span
        >
        <p class="about-title">greyd and its behind story...</p>
      </section>
      <img
        class="about-logo-box"
        src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/grey-box.png"
      />
      <img
        class="about-logo"
        src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/about-logo.png"
      />
      <section class="about-content-container-1">
        <p class="about-content">
          <span v-html="$t('about.about1.content1')"></span>
        </p>
        <br />
        <p class="about-content">
          <span v-html="$t('about.about1.content2')"></span>
        </p>
        <br />
        <p class="about-content">
          <span v-html="$t('about.about1.content3')"></span>
        </p>
      </section>
    </div>

    <div class="about-container-2">
      <img
        class="ryan-img"
        src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/ryan.png"
      />
      <img
        class="about-container-2-grey-square"
        src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/grey-box.png"
      />
      <img
        class="ryan-img-square"
        src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/opacity-outline.png"
      />
      <img
        class="dot-square-img"
        src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/dot-square.png"
      />

      <section class="about-title-container-2">
        <span class="about-header"
          >About <span style="color: white">2/6</span></span
        >
        <p class="about-title" style="z-index: 2">how we started...</p>
      </section>

      <section class="about-content-container-2">
        <p class="about-content">
          <span v-html="$t('about.about2.content1')"></span>
        </p>
        <br />

        <p class="about-content">
          {{ $t("about.about2.content2") }}
        </p>
      </section>

      <div class="company-info">
        <img
          class="ryan-sentence"
          src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/ryan-sentence.png"
        />
        <img
          class="ryan-sign"
          src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/ryan-sign.png"
        />
        회사명: 주식회사 알바임<br />
        대표이사: Seol Ryan Hyungeu<br />
        주요사업: IT, 플랫폼 개발<br />
        소재지: 서울특별시 강남구 학동로 212, 305호
      </div>
    </div>

    <div class="about-container-3">
      <section class="about-title-container-3">
        <span class="about-header"
          >About <span style="color: white">3/6</span></span
        >
        <p class="about-title" style="z-index: 2">brand story</p>
      </section>

      <div class="about-3-content">
        <span v-html="$t('about.about3.content1')"></span>
        <!-- <div class="black-dot"></div>
        <div class="white-dot"></div> -->
      </div>

      <section class="global-app">
        <div class="ecommerce">
          <div class="logos">
            <img
              class="ecommerce-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/shopify.png"
            />
            <img
              class="ecommerce-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/taobao.png"
            />
            <img
              class="ecommerce-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/amazon.png"
            />
            <img
              class="ecommerce-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/walmart.png"
            />
          </div>

          <div class="logos">
            <img
              class="ecommerce-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/coupang.png"
            />
            <img
              class="ecommerce-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/rakuten.png"
            />
            <img
              class="ecommerce-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/alibaba.png"
            />
            <img
              class="ecommerce-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/ebay.png"
            />
          </div>

          <div class="ecommerce-button-container">
            <span class="ecommerce-button">eCommerce</span>
          </div>
        </div>

        <span class="plus">+</span>

        <div class="sns">
          <div class="logos">
            <img
              class="sns-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/facebook.png"
            />
            <img
              class="sns-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/instagram.png"
            />
            <img
              class="sns-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/twitter.png"
            />
          </div>
          <div class="logos">
            <img
              class="sns-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/youtube.png"
            />
            <img
              class="sns-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/tiktok.png"
            />
            <img
              class="sns-logo"
              src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/linkedin.png"
            />
          </div>
          <div class="ecommerce-button-container">
            <span class="ecommerce-button">SNS</span>
          </div>
        </div>

        <span class="equal">=</span>

        <div class="greyd">
          <img
            class="greyd-logo"
            src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/greyd.png"
          />
          <div class="ecommerce-button-container">
            <span class="ecommerce-button">greyd</span>
          </div>
        </div>
      </section>
    </div>

    <div class="about-hexagon-background">
      <div class="greyd-introduction">
        <img
          class="bottom-arrows"
          src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/bottom-arrows.png"
        />

        <img
          class="grey-d"
          src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/grey%2Bd.png"
        />

        <img
          class="bottom-dots"
          src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/bottom-dots.png"
        />

        <img
          class="spectrum"
          src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/greyd-spectrum.png"
        />

        <p class="greyd-introduction-content">
          <span v-html="$t('about.about3.content2')"></span>
        </p>
      </div>

      <!-- <img class="ttcci-cube" src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/ttcci-cube-new.png" /> -->
      <section class="about-title-container-4">
        <div class="about-4-content">
          <span class="about-header"
            >About <span style="color: white">4/6</span></span
          >
          <p class="about-title" style="z-index: 2">
            logo and its<br />
            philosophy behind...
          </p>

          <p
            class="greyd-logo-introduction-content"
            v-html="$t('about.about4.content1')"
          ></p>
        </div>
      </section>

      <section class="ttcci-container">
        <!-- <img
          class="greyd-logo-border"
          src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/greyd-logo-border.png"
        /> -->
        <div class="ttcci-content">
          {{$t('about.about4.content2')}}

          <br />
          <br />
          <span class="ttcci-font">
            {{$t('about.about4.content3')}}
          </span>
          <br />
          <br />

          <p class="ttcci-paragraph">
            <span class="ttcci-font">Truth</span> - {{$t('about.about4.ttcci1')}}
          </p>

          <p class="ttcci-paragraph">
            <span class="ttcci-font">Trust</span> - {{$t('about.about4.ttcci2')}}
          </p>

          <p class="ttcci-paragraph">
            <span class="ttcci-font">Creative</span> - {{$t('about.about4.ttcci3')}}
          </p>

          <p class="ttcci-paragraph">
            <span class="ttcci-font">Challenge</span> - {{$t('about.about4.ttcci4')}}
          </p>

          <p class="ttcci-paragraph">
            <span class="ttcci-font">Innovate</span> - {{$t('about.about4.ttcci5')}}
          </p>
        </div>
      </section>

      <img
        class="g6"
        src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/g6.png"
      />
      <section class="about-title-container-5">
        <span class="about-header"
          >About <span style="color: white">5/6</span></span
        >
        <p class="about-title" style="z-index: 2">{{$t('about.about5.title')}}</p>
        <p class="tier-introduction">
          {{$t('about.about5.content')}}
        </p>
      </section>

      <div class="tier-box">
        <div class="tier-box-content">
          <div class="tier-box-content-image">
            <div class="tier-box-title">티어</div>
            <div class="tier-box-tier-imgs">
              <span class="tier-box-tier-img">Pioneer</span>
              <span class="tier-box-tier-arrow-pioneer">></span>
            </div>

            <div class="tier-box-tier-imgs">
              <span class="tier-box-tier-img">Explorer</span>
              <span class="tier-box-tier-arrow-explorer">></span>
            </div>

            <div class="tier-box-tier-imgs">
              <span class="tier-box-tier-img">Striver</span>
              <span class="tier-box-tier-arrow-striver">></span>
            </div>

            <div class="tier-box-tier-imgs">
              <span class="tier-box-tier-img">Operator</span>
              <span class="tier-box-tier-arrow-operator">></span>
            </div>

            <div class="tier-box-tier-imgs">
              <span class="tier-box-tier-img tier-box-img-artisan"
                >Artisan</span
              >
              <span class="tier-box-tier-arrow-pioneer tier-box-arrow">></span>
              <span class="tier-box-tier-arrow-explorer tier-box-arrow">></span>
              <span class="tier-box-tier-arrow-giver">></span>
            </div>

            <div class="tier-box-tier-imgs-giver">Giver</div>
          </div>

          <div style="display: flex">
            <div style="width: 10%"></div>
            <hr style="width: 90%; background: #a0a0a0" />
          </div>

          <div class="tier-box-content-desc">
            <div class="tier-box-title">설명</div>
            <div class="tier-box-content-desc-span" v-html="$t('about.about5.description.pioneer')">
            </div>
            <div class="tier-box-content-desc-span" v-html="$t('about.about5.description.explorer')">
            </div>
            <div class="tier-box-content-desc-span" v-html="$t('about.about5.description.striver')">
            </div>
            <div class="tier-box-content-desc-span" v-html="$t('about.about5.description.operator')">
            </div>
            <div class="tier-box-content-desc-span" v-html="$t('about.about5.description.artisan')">
            </div>
            <div class="tier-box-content-desc-giver">
              <span style="font-weight: 600; color: #ffb731">{{$t('about.about5.description.giver')}}</span>
            </div>
          </div>

          <div style="display: flex">
            <div style="width: 10%"></div>
            <hr style="width: 90%; background: #a0a0a0" />
          </div>

          <div class="tier-box-content-profit">
            <div class="tier-box-title">수익률</div>
            <span class="tier-box-profit">0%</span>
            <span class="tier-box-profit">2%</span>
            <span class="tier-box-profit">4%</span>
            <span class="tier-box-profit">6%</span>
            <span class="tier-box-profit">8%</span>
            <span class="tier-box-profit-giver">10%</span>
          </div>
        </div>
      </div>
    </div>

    <div class="about-container-6">
      <section class="about-title-container-6">
        <span class="about-header"
          >About <span style="color: white">6/6</span></span
        >
        <p class="about-title" style="z-index: 2">{{$t('about.about6.title')}}</p>
        <p class="tier-introduction-6">
          {{$t('about.about6.content')}}
        </p>
      </section>

      <section class="g6-images">
        <div class="g6-image-contianer">
          <img
            class="g6-image"
            src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/hexagon-g.png"
          />
          <p class="g6-image-text">
            {{$t('about.about6.description1')}}
          </p>
        </div>
        <div class="g6-image-contianer">
          <img
            class="g6-image"
            src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/hexagon-outline.png"
          />
          <p class="g6-image-text">
            {{$t('about.about6.description2')}}
          </p>
        </div>
        <div class="g6-image-contianer">
          <img
            class="g6-chart-image"
            src="https://s3.ap-northeast-2.amazonaws.com/greyd.web/compressed/g6chart.png"
          />
          <p class="g6-image-text">
            {{$t('about.about6.description3')}}
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data () {
    return {
      isActive: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="@/assets/styles/about.css"></style>
<style scoped src="@/assets/styles/about-mobile.css"></style>



// WEBPACK FOOTER //
// src/components/renewal/components/About.vue